import { createFileRoute } from '@tanstack/react-router';

import { InspectionProgressPage } from '@/pages/inspection/progress/InspectionProgressPage';

function MemberInspectionProgressRoute() {
	const { inspectionId } = Route.useParams();
	return <InspectionProgressPage inspectionId={inspectionId} />;
}

export const Route = createFileRoute(
	'/_authenticated/_app/chain/companies/$memberId/inspections/$inspectionId/progress',
)({
	component: MemberInspectionProgressRoute,
});
